import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Logo from '../../assets/images/logo.svg';
import { useDispatch } from 'react-redux';
import { profile } from '../../redux/reducers/ProfileSlice';
import { FaChevronDown, FaChevronUp, FaUser, FaSignOutAlt } from "react-icons/fa";
import { FaXTwitter } from 'react-icons/fa6';
import { logoutAuth } from '../../redux/reducers/AuthSlice';
import Toast from '../../utils/toast';
import { setting } from '../../redux/reducers/HomePageSlice';

const Header = () => {

  const dispatch = useDispatch();

  const { isLoggedIn } = useSelector((state) => state.authUser || {});
  const navigate = useNavigate();
  const [isFixed, setIsFixed] = useState(false);
  const [profileData, setProfileData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [social, setSocial] = useState();

  useEffect(() => {
    const settingData = async () => {
      try {
        const responseSetting = await dispatch(setting());
        setSocial(responseSetting.payload.data);
      } catch (error) {
        // Error fetching setting data
      }
    };
    settingData();
  }, [dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      const height = window.scrollY;
      if (height >= 100) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logoutAuth());
    Toast('success', 'You have been logged out successfully.');
    navigate('/login');
    window.location.reload();
  };


  const handleNavigation = (id) => {
    navigate("/");
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      if (!isLoggedIn) {
        setProfileData(undefined);
        return;
      }

      try {
        const responseProfile = await dispatch(profile());
        setProfileData(responseProfile.payload.data);
      } catch (error) {
        // Error fetching profile data
      }
    };
    fetchProfile();
  }, [dispatch, isLoggedIn]);

  const handleMenuClose = () => {
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector("#navbarSupportedContent");
    const barIcon = document.querySelector(".bar_icon");
    const closeIcon = document.querySelector(".close_icon");

    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");

      if (barIcon && closeIcon) {
        barIcon.style.display = "block";
        closeIcon.style.display = "none";
      }
    }

    if (navbarToggler) {
      navbarToggler.classList.remove("show");
    }
  };

  return (
    <header>
      <section className="topbar">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-9 d-none d-md-block">
              <ul className="topbar_link d-flex flex-wrap">
                <li>
                  {social?.phone && (
                    <a href={`tel:${social.phone}`}>
                      <i className="fas fa-phone-alt"></i> {social.phone}
                    </a>
                  )}
                </li>
                <li>
                  {social?.email && (
                    <a href={`mailto:${social.email}`}>
                      <i className="fas fa-envelope"></i> {social.email}
                    </a>
                  )}
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-lg-3 d-md-none d-lg-block">
              <ul className="topbar_icon d-flex flex-wrap">
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61574616240718"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/teledoc_onlineclinic"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCvCxoQKHY6ksRQ5IqoM8eWQ"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="YouTube"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/Teledoc_clinic"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="X (Twitter)"
                  >
                    <FaXTwitter />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <nav
        className={`navbar navbar-expand-xxl main_menu ${isFixed ? 'menu_fix' : ''
          }`}>
        <div className="container">
          <Link className="navbar-brand" to="/home">
            <img
              src={social?.company_logo || Logo}
              alt="Teledoc - Online Doctor Consultation"
              className="img-fluid w-100"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              const navbarCollapse = document.querySelector("#navbarSupportedContent");
              const barIcon = document.querySelector(".bar_icon");
              const closeIcon = document.querySelector(".close_icon");

              navbarCollapse.classList.toggle("show");

              if (navbarCollapse.classList.contains("show")) {
                barIcon.style.display = "none";
                closeIcon.style.display = "block";
              } else {
                barIcon.style.display = "block";
                closeIcon.style.display = "none";
              }
            }}
          >
            <i className="fas fa-bars bar_icon"></i>
            <i className="fas fa-times close_icon" style={{ display: "none" }}></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={handleMenuClose}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#!" onClick={() => { handleNavigation("about"); handleMenuClose(); }}>
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/what-we-treat" onClick={handleMenuClose}>
                  What We Treat
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#!" onClick={() => { handleNavigation("faqs"); handleMenuClose(); }}>
                  FAQs
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#!" onClick={() => { handleNavigation("testimonials"); handleMenuClose(); }}>
                  Testimonials
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href='https://teledoc.co.in/blog/' target='_blank' rel="noreferrer" onClick={handleMenuClose}>
                  Blog
                </a>
              </li>
            </ul>
            <ul className="menu_btn pl_10 header-buttons">
              <li>
                <Link to="/book-appointment" className="common_btn" onClick={handleMenuClose}>
                  Book an Appointment
                </Link>
              </li>
              {!isLoggedIn && (
                <li>
                  <Link to="/login" className="common_btn" onClick={handleMenuClose}
                    style={{ background: 'transparent', border: '2px solid #3399cc', color: '#3399cc' }}>
                    Login
                  </Link>
                </li>
              )}
              {profileData && (
                <li className="header-profile">
                  <div
                    className="header-profile-div"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen(!isOpen);
                    }}
                  >
                    <img
                      src={profileData?.image}
                      alt="user"
                      className="header-profile-image"
                    />
                    <span className="arrow-icon">
                      {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  </div>

                  <ul className={`dropdown-menu ${isOpen ? "show" : ""}`}>
                    <Link to='/dashboard' onClick={() => setIsOpen(false)} className="dropdown-link">
                      <li className="dropdown-item" onClick={handleMenuClose}>
                        <span> <FaUser /> Profile </span>
                      </li>
                    </Link>

                    <li className="dropdown-item logout-item" onClick={() => {
                      handleLogout();
                      handleMenuClose();
                    }}>
                      <FaSignOutAlt /> Logout
                    </li>
                  </ul>
                </li>
              )}

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
